
/* injects from baggage-loader */

'use strict';

export default class HeaderController {
    constructor($log, User) {
        'ngInject';

        this.$log = $log;
        this.UserService = User;

        this.user = {};
        this.showMobileMenu = false;
        this.showAccountDropdown = false;
        this.showSearchField = false;

        // Links shown on the header
        this.links = [
            {
                title: 'Projects',
                state: 'projects'
            },
            {
                title: 'Learn',
                state: 'learn'
            },
            // {
            //     title: 'Raise Funds',
            //     state: 'raise-funds'
            // },
            {
                title: 'Blog',
                href: 'https://blog.commonowner.com'
            }
        ];

        // Account dropdown links
        this.account_links = [
            {
                title: 'My Account',
                state: 'account.home'
            },
            {
                title: 'Logout',
                state: 'accountLogout'
            }
        ]

    }

    $onInit() {

        // Current user account
        this.user = this.UserService.getCurrent();

    }

    /**
     * Return the current user else returns false
     */
    userLoggedIn() {
        return this.UserService.isUserLoggedIn();
    }

    toggleAccountDropdown() {
        this.showAccountDropdown = !this.showAccountDropdown;
    }

    toggleMobileMenu() {
        this.showMobileMenu = !this.showMobileMenu;
    }

    toggleSearchField() {
        this.showSearchField = !this.showSearchField;
    }

    getUserInitials() {
       
    }
}


// WEBPACK FOOTER //
// ./src/app/components/header/header.controller.js